import React from 'react';
import { useTheme } from '@mui/material';
import { StyledSvg } from './StyledSvg';

const PageSad: React.FC<
	Omit<React.ComponentProps<typeof StyledSvg>, 'children'>
> = ({ ...props }) => {
	const theme = useTheme();

	const strokeColor = theme.palette.primary.main;
	const fill1 = theme.palette.secondary.light;
	const fill2 = theme.palette.primary.light;

	return (
		<StyledSvg viewBox="0 0 300 300" {...props}>
			<path
				d="M66.1055 44.6479C52.8506 44.6479 42.1055 55.3931 42.1055 68.648V79.3516V220.648C42.1055 233.903 52.8506 244.648 66.1055 244.648H233.895C247.149 244.648 257.895 233.903 257.895 220.648V79.3516V68.648C257.895 55.3931 247.149 44.6479 233.895 44.6479H66.1055Z"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M83.6117 64.2538C83.6257 64.9363 83.5033 65.6148 83.2517 66.2495C83.0001 66.8842 82.6245 67.4623 82.1467 67.9499C81.6689 68.4376 81.0986 68.825 80.4692 69.0895C79.8398 69.354 79.1639 69.4902 78.4812 69.4902C77.7985 69.4902 77.1226 69.354 76.4932 69.0895C75.8638 68.825 75.2935 68.4376 74.8157 67.9499C74.3379 67.4623 73.9622 66.8842 73.7107 66.2495C73.4591 65.6148 73.3367 64.9363 73.3507 64.2538C73.3781 62.9112 73.9307 61.6329 74.8899 60.6932C75.8491 59.7534 77.1384 59.2271 78.4812 59.2271C79.824 59.2271 81.1133 59.7534 82.0725 60.6932C83.0317 61.6329 83.5843 62.9112 83.6117 64.2538Z"
				fill={fill2}
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M68.3511 64.2536C68.3511 65.6146 67.8104 66.9199 66.8481 67.8822C65.8857 68.8446 64.5805 69.3852 63.2195 69.3852C61.8585 69.3852 60.5533 68.8446 59.5909 67.8822C58.6285 66.9199 58.0879 65.6146 58.0879 64.2536C58.0879 62.8927 58.6285 61.5874 59.5909 60.6251C60.5533 59.6627 61.8585 59.1221 63.2195 59.1221C64.5805 59.1221 65.8857 59.6627 66.8481 60.6251C67.8104 61.5874 68.3511 62.8927 68.3511 64.2536Z"
				fill={fill1}
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M99.3413 64.2537C99.3413 65.2686 99.0403 66.2607 98.4765 67.1046C97.9126 67.9485 97.1112 68.6062 96.1735 68.9946C95.2358 69.383 94.204 69.4847 93.2086 69.2866C92.2132 69.0886 91.2988 68.5999 90.5811 67.8822C89.8635 67.1646 89.3747 66.2502 89.1767 65.2548C88.9787 64.2593 89.0803 63.2276 89.4687 62.2899C89.8571 61.3522 90.5149 60.5508 91.3588 59.9869C92.2026 59.423 93.1948 59.1221 94.2097 59.1221C95.5697 59.1255 96.8729 59.6672 97.8346 60.6288C98.7962 61.5905 99.3379 62.8937 99.3413 64.2537Z"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.47559 81.4902H293.581"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="99.3418"
				y="101.352"
				width="25"
				height="50"
				fill={fill1}
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="74.3418"
				y="196.747"
				width="25"
				height="25"
				fill={fill1}
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="199.342"
				y="196.747"
				width="25"
				height="25"
				fill={fill1}
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="174.342"
				y="101.352"
				width="25"
				height="50"
				fill={fill1}
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="199.342"
				y="171.747"
				width="25"
				height="100"
				transform="rotate(90 199.342 171.747)"
				fill={fill1}
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18.9072 140.533L29.7804 153.502"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M202.251 18.165L213.124 31.1342"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M269.356 206.928L280.23 219.897"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M144.565 215.262L155.439 228.231"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M30.8441 141.591L17.8402 152.444"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M214.188 19.2222L201.184 30.0754"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M281.293 207.986L268.289 218.839"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M156.502 216.32L143.498 227.173"
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M257.895 220.648V231.352C257.895 244.607 247.149 255.352 233.895 255.352H66.1055C52.8506 255.352 42.1055 244.607 42.1055 231.352V220.648C42.1055 233.903 52.8506 244.648 66.1055 244.648H233.895C247.149 244.648 257.895 233.903 257.895 220.648Z"
				fill={fill2}
				stroke={strokeColor}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</StyledSvg>
	);
};

export default PageSad;
